<template>
    <div class="flex wrap">
        <div class="space-between">
        <field-input v-model="form.name" placeholder="Name"></field-input>
        <field-input v-model="form.label" placeholder="Label"></field-input>
            <div class="space-between checkbox-list">
                <div class="form-group">
                    <label>Permissions</label>
                    <div class="flex wrap">
                        <div class="check-item" v-for="permission in permissions">
                            <p-check v-model="form.permissions" :value="permission.id" name="check" color="success">{{ permission.label }}</p-check>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {

        props: {
            form: {
                type: Object,
                required: true,
            }
        },

        data() {
            return {
                permissions: [],
            }
        },

        watch: {
            form(newValue) {
                this.form.permissions = _.map(this.form.permissions, permission => { return permission.id })
            }
        },

        created() {
            App.request().get('/management/permissions').then(response => {
                this.permissions = response.data
                this.form.permissions = _.map(this.form.permissions, permission => { return permission.id })
            })
        },
    }
</script>
